import { types } from '../../actions/warehouse_rent_list_actions'
import {
  WarehouseRentListState,
  WarehouseRentListAction,
  LoadDataAction,
  RentElementAction,
  RentElementFailureAction,
  RentItem,
} from '../../components/elements/warehouse_rent_list_app/warehouse_rent_list/warehouse_rent_list_types'

const initialState: WarehouseRentListState = {
  rentList: null,
  startDate: null,
  endDate: null,
  groupedAvailableElements: {},
  elementGroups: {},
  rentedItems: {},
  initialRentedItems: {},
  rentElementRequestInProgress: false,
  errors: [],
}

export default function warehouseRentList(
  state: WarehouseRentListState = initialState,
  action: WarehouseRentListAction
): WarehouseRentListState {
  switch (action.type) {
    case types.LOAD_DATA: {
      const loadAction = action as LoadDataAction
      return {
        ...state,
        rentList: loadAction.data.rentList,
        startDate: loadAction.data.startDate,
        endDate: loadAction.data.endDate,
        groupedAvailableElements: loadAction.data.groupedAvailableElements,
        elementGroups: loadAction.data.elementGroups,
        rentedItems: loadAction.data.rentedItems,
        initialRentedItems: loadAction.data.rentedItems,
      }
    }

    case types.RENT_ELEMENT_REQUEST:
      return {
        ...state,
        rentElementRequestInProgress: true,
        errors: [],
      }

    case types.RENT_ELEMENT: {
      const rentAction = action as RentElementAction
      const elementId = rentAction.data.element.id
      const existingItems = state.rentedItems[elementId] || []
      const rentListId = rentAction.data.rentList?.id || state.rentList?.id
      
      // Check if this is a deletion (marked by backend)
      if ((rentAction.data as any).deleted) {
        // Remove item for this rent list
        const updatedItems = existingItems.filter(
          (item) => item.rentList.id !== rentListId
        )
        
        return {
          ...state,
          rentElementRequestInProgress: false,
          rentedItems: {
            ...state.rentedItems,
            [elementId]: updatedItems,
          },
        }
      }
      
      // Find existing item for this rent list
      const existingItemIndex = existingItems.findIndex(
        (item) => item.rentList.id === rentListId
      )
      
      let updatedItems: RentItem[]
      if (existingItemIndex >= 0) {
        // Update existing item
        updatedItems = [...existingItems]
        updatedItems[existingItemIndex] = rentAction.data
      } else {
        // Add new item
        updatedItems = [...existingItems, rentAction.data]
      }
      
      return {
        ...state,
        rentElementRequestInProgress: false,
        rentedItems: {
          ...state.rentedItems,
          [elementId]: updatedItems,
        },
      }
    }

    case types.RENT_ELEMENT_FAILURE: {
      const failureAction = action as RentElementFailureAction
      return {
        ...state,
        rentElementRequestInProgress: false,
        errors: [failureAction.error.response.data.error],
      }
    }

    case types.CLEAR_ERRORS:
      return {
        ...state,
        errors: [],
      }

    default:
      return state
  }
}
